import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import GroupSection from './GroupSection';

const GetUserInfoQuery = gql`
  query GroupSectionUserInfo {
    userInfo {
      id
      
      email
      phone
      
      receiveNewsletter
      
      companyInformation
      companyName
      companyRegistrationNumber
      companyVatNumber

      invoiceFirstName
      invoiceLastName
      
      invoiceStreet
      invoiceHouseNumber
      invoiceAddressLine1
      invoiceAddressLine2
      invoiceZip
      invoiceCity
      invoiceCountyState
      invoiceCountry

      anotherDeliveryAddress
      deliveryPhone
      deliveryStreet
      deliveryHouseNumber
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryZip
      deliveryCity
      deliveryCountyState
      deliveryCountry

      saleTaxCertificate

      customerGroup {
        id
        name
        discount
        fields
        description
      }

      customerGroups {
        id
        name
        discount
        description
        fields
      }

      customerGroupsData
    }
  }
`;

const UpdateUserInfoMutation = gql`
  mutation updateUserInfo($user: IUserInput!) {
    updateUserInfo(userData: $user)
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(GetUserInfoQuery, {
    options: {
      fetchPolicy: 'network-only',
    },
  }),
  graphql<IInputProps, IResponse>(UpdateUserInfoMutation, {
    name: 'updateUserInfo'
  })
)(GroupSection);



// WEBPACK FOOTER //
// ./src/pages/GroupSection/index.tsx